import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import { useEffect, useState, type PropsWithChildren } from 'react';

const FORCE_CLOSE_EVENT = 'byhelp:force-close-modals';

export const useForceCloseModal = (close: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handler = () => close();

    window.addEventListener(FORCE_CLOSE_EVENT, handler);
    return () => window.removeEventListener(FORCE_CLOSE_EVENT, handler);
  }, [close, enabled]);
};

export const CheckNetworkProvider = ({ children }: PropsWithChildren) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleOnline = () => {
    setShowModal(false);
  };
  const handleOffline = () => {
    Modal.destroyAll();
    window.dispatchEvent(new Event(FORCE_CLOSE_EVENT));
    setShowModal(true);
  };

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {children}
      <Modal
        open={showModal}
        title={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <ExclamationCircleFilled
              style={{ marginRight: 8, color: '#faad14', fontSize: '22px' }}
              width={22}
              height={22}
            />
            Отсутствует подключение к интернету
          </span>
        }
        centered
        okText="Понятно"
        onOk={() => setShowModal(false)}
        width="max-content"
        okType="primary"
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => setShowModal(false)}
        closable={false}
      >
        <p>Пожалуйста, проверьте ваше интернет-соединение.</p>
      </Modal>
    </>
  );
};
